import React from "react";
import { useNavigate } from "react-router-dom";

import {
  LinkIcon,
  HeartIcon,
  ThumbIcon,
  LocationIcon,
  LeftArrowIcon,
  AreaOutlineIcon,
} from "../../assets/icons";
import PropertyTypesIconMapping from "../../assets/icons/PropertyTypesIconMapping";
import { EMPTY_STRING } from "../../constants/global.constants";
import {
  numberFormatting,
  formatToTwoDecimalPlaces,
} from "../../shared/utility";
import CustomSvg from "../../shared/components/custom-svg/CustomSvg";
import RoundedButton from "../../shared/components/buttons/RoundedButton";
import Slider from "./Slider";

const ImageSlider = ({
  property,
  isFavourite,
  isInterested,
  isFavouriteHandle,
  isInterestedHandle,
  slideCurrentIndex,
  setSlideCurrentIndex,
  isFromFavourites,
  getConvertedValue,
  currencySymbol,
  propertyDetail,
  hasUserRole,
  expandSlider,
}) => {
  const navigate = useNavigate();
  return (
    <div className="image-slide-wrapper">
      <div className="row d-flex justify-content-between align-items-center">
        <div className="col-6">
          <div className="pointer d-inline" onClick={() => navigate(-1)}>
            <img src={LeftArrowIcon} alt="Left Arrow" className="back-button" />
          </div>
        </div>
        {hasUserRole && (
          <div className="col-6 d-flex flex-column align-items-end">
            {isFromFavourites ? (
              <button
                type="button"
                onClick={() => isFavouriteHandle()}
                className={`not-interested-button rounded-pill ${
                  !isFavourite ? "active" : EMPTY_STRING
                }`}
              >
                <div className="d-flex align-items-center gap-2">
                  <img src={ThumbIcon} alt="Unlike" />
                  Unlike
                </div>
              </button>
            ) : (
              <>
                <button
                  type="button"
                  onClick={() => isFavouriteHandle()}
                  className={`rounded-pill mark-as-favourite-button ${
                    isFavourite ? "active" : EMPTY_STRING
                  }`}
                >
                  <div className="d-flex align-items-center gap-2">
                    <img src={HeartIcon} alt="favourite" />
                    Mark as Favourite
                  </div>
                </button>
                <button
                  type="button"
                  onClick={() => isInterestedHandle()}
                  className={`not-interested-button rounded-pill mt-3 ${
                    isInterested ? "active" : EMPTY_STRING
                  }`}
                >
                  <div className="d-flex align-items-center gap-2">
                    <img src={ThumbIcon} alt="Not Interested" />
                    Not Interested
                  </div>
                </button>
              </>
            )}
          </div>
        )}
      </div>
      <div className="image-slider__property-info property-features-wrapper">
        <div className="row">
          <div className="col-12 col-xl-9">
            <h2
              className="property-title line-clamp line-clamp-2 px-2"
              title={property?.title}
            >
              {property?.title}
            </h2>
            <div className="d-flex mt-4 column-gap-3 column-gap-lg-5 px-2 flex-wrap row-gap-2">
              {property?.propertyType?.slice(0, 3)?.map((type) => (
                <div className="d-flex align-items-center gap-2 gap-lg-3">
                  <div className="property-icon">
                    <CustomSvg
                      color="#fff"
                      alt="property type"
                      src={PropertyTypesIconMapping[type.icon]}
                    />
                  </div>
                  <div className="property-icon-text">{type.title}</div>
                </div>
              ))}

              <div className="d-flex align-items-center gap-2 gap-lg-3">
                <div className="property-icon">
                  <img alt="area" src={AreaOutlineIcon} />
                </div>
                <div className="property-icon-text">
                  {property?.area}{" "}
                  {property?.areaMeasurementType === 1 ? "m" : "f"}
                  <sup> 2</sup>
                </div>
              </div>
              <div className="d-flex align-items-center gap-2 gap-lg-3">
                <div className="property-icon">
                  <img alt="location" src={LocationIcon} />
                </div>
                <div className="property-icon-text">
                  {property?.location?.city}
                </div>
              </div>
            </div>
          </div>
          <div className="col-12 col-xl-3 d-flex justify-content-start justify-content-sm-end align-items-end">
            <div className="ps-2 ps-sm-0 mt-2 mt-xl-0">
              <div className="d-flex gap-2">
                {propertyDetail?.isTaxFree && (
                  <RoundedButton className="details-additional-info-btn">
                    Tax Free
                  </RoundedButton>
                )}
                {propertyDetail?.isVisaFree && (
                  <RoundedButton className="details-additional-info-btn">
                    Visa Free
                  </RoundedButton>
                )}
              </div>
              <div className="property-price my-2">
                <div className="d-flex align-items-center gap-2">
                  <div>
                    {hasUserRole
                      ? currencySymbol
                      : propertyDetail?.currency?.symbol}
                  </div>
                  <div>
                    {hasUserRole
                      ? numberFormatting(getConvertedValue(property?.price))
                      : numberFormatting(
                          formatToTwoDecimalPlaces(propertyDetail?.price)
                        )}
                  </div>
                </div>
              </div>
              <Slider
                length={property?.images?.length}
                slideCurrentIndex={slideCurrentIndex}
                setSlideCurrentIndex={setSlideCurrentIndex}
              />
              <RoundedButton
                onClick={expandSlider}
                className="expand-slider-text"
              >
                Expand Images{" "}
                <img src={LinkIcon} alt="expand" className="ms-1" />
              </RoundedButton>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ImageSlider;
